import { useMemo } from "react";
import { useSwivuBryntumContext } from "@/react/hooks/useSwivuBryntumContext";
import { useSwivuStore } from "@/react/hooks/useSwivuStore";
import { STORE_KEYS } from "@/other/constants/StoreKeys";
import { MarketingPage } from "@/bryntum-lib/models/MarketingPage";

export function useMarketingPages() {
  const { project } = useSwivuBryntumContext();

  const { version: pagesVersion } = useSwivuStore({
    storeId: STORE_KEYS.marketingPageStore,
  });

  const pages = useMemo<MarketingPage[]>(() => {
    if (!project) return [];
    const store = project.getCrudStore(STORE_KEYS.marketingPageStore);
    if (!store) return [];
    const rows = store.query(() => true) as unknown as MarketingPage[];
    return [...rows].sort((a, b) => {
      const ta = a.updatedAt ? new Date(a.updatedAt).getTime() : 0;
      const tb = b.updatedAt ? new Date(b.updatedAt).getTime() : 0;
      return tb - ta;
    });
  }, [project, pagesVersion]);

  return { pages };
}
